<template>
  <div class="task-progress-item">
    <h1 class="highlight my-8px">奖品名称：{{ itemData.prizeName }}</h1>

    <div class="mx-1">
      <h1 class="highlight my-8px">任务要求：</h1>
      <div class="mx-1">
        <el-checkbox-group :value="checkList" v-if="itemData.tasks && itemData.tasks.length">
          <div class="flex flex-column">
            <el-checkbox :label="task.taskId" v-for="task in itemData.tasks" :key="task.taskId">{{ task.taskName || '' }}</el-checkbox>
          </div>
        </el-checkbox-group>
        <div v-else>无</div>
      </div>

      <h1 class="highlight my-8px">{{ itemData.prizeLimitType === 30 ? '家庭成员' : '' }}领取数量：</h1>
      <div class="mx-1">
        <div class="flex justify-between py-4px px-2px my-2px header">
          <span>限领份数</span>
          <span>{{ itemData.prizeLimitType === 10 ? '不限份数' : itemData.prizeLimitNum+'份' }}</span>
        </div>

        <div class="flex justify-between py-4px px-2px my-2px" v-for="(pick, index) in itemData.picks" :key="index">
          <span>{{ pick.userName }}已领</span>
          <span>{{ pick.writeOffNum }} 份</span>
        </div>

        <div class="flex justify-between py-4px px-2px my-2px">
          <span>合计已领</span>
          <span>{{ pickedNum }} 份</span>
        </div>

        <div class="flex justify-between py-4px px-2px my-2px" v-if="isWriteOff">
          <span>本次发放</span>
          <span class="font-red">
            <el-input-number :disabled="isAllPicked" :min="0" :max="maxWriteOffNum" size="mini" v-model="writeOffNum" @change="handleWriteOffNumChange" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskProgressItem",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    /** 本次核销数 */
    value: {
      type: Number,
      default: 0
    },
    checkable: {
      type: Boolean,
      default: true
    },
    /** 是否是核销类型 */
    isWriteOff: {
      type: Boolean,
      default: false
    },

    itemData: {
      type: Object,
      default: () => ({
        "prizeId": "1742002379030675457",
        "prizeName": "兴业&智小美生活卡",
        "prizeType": 10,
        "prizeLimitType": 20,
        "prizeLimitNum": 5,
        "tasks": [
          {
            "taskId": "1742122027822854145",
            "taskName": null,
            "demand": 1,
            "state": true
          }
        ],
        "picks": [
          {
            "userId": "121283",
            "userName": "智智测试",
            "writeOffNum": 1,
            "writeOffState": true,
            "createAt": 1704244224000
          }
        ]
      })
    },
  },
  data() {
    return {
      checkList: [],

      /** 本次发放数 */
      writeOffNum: 1,
    }
  },
  computed: {
    /** 合计领取数量 */
    pickedNum() {
      return this.itemData.picks.map(item => item.writeOffNum).reduce((i, j) => i+j, 0)
    },
    /** 是否全部领取完 */
    isAllPicked() {
      if (this.itemData.prizeLimitType === 10) {
        return false
      }

      return this.pickedNum === this.itemData.prizeLimitNum
    },
    /** 本次最大发放数 */
    maxWriteOffNum() {
      let {prizeLimitType, prizeLimitNum} = this.itemData
      if (prizeLimitType === 10) {
        return Infinity
      }

      let delta = prizeLimitNum - this.pickedNum
      return delta > 0 ? delta : 0
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
      },
    }
  },
  mounted() {
    this.checkList = this.itemData.tasks?.filter(item => item.state).map(item => item.taskId) || []
    let amount = this.isAllPicked ? 0 : this.maxWriteOffNum
    amount = amount === Infinity ? 1 : amount
    this.writeOffNum = amount
    this.handleWriteOffNumChange(amount)
  },
  methods: {
    handleWriteOffNumChange(data) {
      this.$emit('change', data)
    },
  },
}
</script>

<style lang="less" scoped>
.task-progress-item {
  h1.highlight{
    font-size: 14px;
    font-weight: normal;
  }

  .header {
    background: #EEF1F6;
  }

  /deep/ .el-checkbox-group {
    .el-checkbox {
      margin: 4px 0;
    }
    
    .el-checkbox__input,.el-checkbox {
      cursor: default;
    }
  }
}
</style>